import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DatePickerModule } from 'primeng/datepicker';
import { TableModule } from 'primeng/table';

@Component({
  selector: 'app-custom-date-filter',
  templateUrl: './custom-date-filter.component.html',
  styleUrls: ['./custom-date-filter.component.scss'],
  standalone: true,
  imports: [TableModule, FormsModule, ReactiveFormsModule, DatePickerModule]
})
export class CustomDateFilterComponent {
  @Input() field!: string;
  @Input() control!: FormControl;

  @Output() onChangeDateFilter = new EventEmitter<{ propertyName: string, valueFilter: any }>();

  filterInput(event: any) {
    this.onChangeDateFilter.emit({
      propertyName: this.field,
      valueFilter: String(event.toLocaleDateString('en-CA'))
    });
  }
}
